import Pii from './assets/pii.svg';
import Webcam from './assets/webcam.svg';

export const FILTERS = {
  webcam: {
    icon: Webcam,
    title: 'Webcam',
    description: 'Show surveys that require a webcam',
  },
  pii: {
    icon: Pii,
    title: 'PII',
    description: 'Show surveys that ask for personally identifiable information like name or email',
  },
} as const;
